

export const Texts_EN = {
    LABELS: {
        supportIdeas: "Support Ideas",
        promoteInnovation: "Promote Innovation",
        supportGrowth: "Support Growth",
        createValue: "Create Value",
    }
}

export default Texts_EN;